<template>
    <div class="p-12 container">
        <h2>{{ addingToOrder ? 'Add Managed WordPress' : 'Update Managed WordPress' }}</h2>

        <div class="flex flex-wrap" v-if="config">
            <div class="w-full pb-8 md:w-2/3 md:pr-4">

                <ul class="breadcrumb bg-grey-100 rounded p-4 mb-8">
                    <li class="breadcrumb-item"><router-link to="/order">Order</router-link></li>
                    <template v-if="addingToOrder">
                        <li class="breadcrumb-item active">Managed WordPress</li>
                    </template>
                    <template v-else>
                        <li class="breadcrumb-item"><a href="#" @click.prevent="setItemToEdit(null)">Managed WordPress</a></li>
                        <li class="breadcrumb-item active">Edit</li>
                    </template>
                </ul>

                <p class="mb-4 text-xl text-green">All plans include:</p>

                <ul class="mb-8 pl-4">
                    <li>All management of plugins and themes.</li>
                    <li>2 availability zones, 100% guaranteed uptime.</li>
                    <li>Nimble backed storage.</li>
                    <li>Backups every 15 minutes.</li>
                    <li>All WP updates (CMS, Themes & Plugins) and checks, includes Plesk Power Pack.</li>
                    <li>Rapid SSL Installation or installation of an existing SSL</li>
                </ul>

                <h3 class="mb-6">
                    <span class="text-green">Step 1 - </span>
                    <span class="text-blue">Select your WordPress Package</span>
                </h3>

                <div class="flex flex-wrap -m-4 pb-8">
                    <div class="w-full sm:w-1/2 p-4 flex items-stretch" v-for="(option, index) in config" :key="index">
                        <div class="sau-bundle-card self-stretch w-100">
                            <input type="radio" :id="`wordpress-${index}`" name="package" :value="option.id" v-model="package_id" @change="updateWp()">
                            <label :for="`wordpress-${index}`" class="h-full">
                                <div class="sau-server-box h-full flex flex-col">
                                    <header class="mb-6"><i aria-hidden="true" class="icon icon-sau-dedicated flex-1"></i></header>
                                    <h4 class="text-blue mb-4 px-4 h5">{{ option.name }}</h4>
                                    <p v-html="option.description" class="px-4 mb-6 flex-1 text-left"></p>
                                    <div class="price-box py-2">
                                        <p class="price mb-2">{{ option.price | currency}}</p>
                                        <p class="pm">Per Month Ex. GST</p>
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>

                <h3 class="mb-4">
                    <span class="text-green">Step 2 - </span>
                    <span class="text-blue">Enter your Domain Name</span>
                </h3>

                <div class="mb-4">
                    <!-- <label for="domain">Enter your Domain Name</label> -->
                    <input
                        id="domain"
                        type="text"
                        v-model="domain"
                        @blur="updateWp()"
                        class="form-control"
                        placeholder="Enter Domain"
                        @input="validating = false"
                        v-on:keyup.enter="updateWp()"
                        :disabled="! package_id || addingToOrder"
                        :class="{
                            'border-red bg-red-100': validating && ! domainValid(),
                        }"
                    />
                    <small>Please enter the domain name you would like to use for your Managed WordPress hosting.</small><br>
                    <small>You can <router-link to="/order/domain" title="Register a domain name with Servers Australia">register your domain name</router-link> with Servers Australia.</small>
                </div>
            </div>

            <sau-ordering-sidebar :data="data" :order="order" :processing="false"></sau-ordering-sidebar>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: Object,
        order: Object,
    },

    data() {
        return {
            config: {},
            wordpress: {},
            type: 'managed-wordpress',
            slug: null,
            domain: '',
            package_id: null,
            ready: false,
            // sidebarWidth: '100%',
            // sidebarHeight: 'auto',
            addingAnItem: false,
            validating: false,
        }
    },

    mounted() {

        this.config = this.data.config.products.managedwordpress.packages;

        // If user is returning to a Managed Wordpress Order
        if (this.data.active.managedWordpress) {
            // Set up the state to match the order
            this.setItemToEdit(this.order.items.find(
                item => item.type === this.type && item.slug === this.data.active.managedWordpress
            ));
        }

        window.bus.$on('validate-order-item', item => {
            if (item.slug !== this.activeItem.slug) return

            let valid = true;
            this.validating = true;

            if (! this.domainValid()) {
                valid = false;
            }

            window.bus.$emit(
                valid ? 'order-item-valid' : 'order-item-invalid',
                item
            );
        });
    },

    methods: {
        isValidDomain: require('is-valid-domain'),

        domainValid: function () {
            return this.activeItem
                && this.activeItem.domain
                && this.isValidDomain(this.activeItem.domain);
        },

        setItemToEdit: function (item) {
            this.data.active.managedWordpress = item && item.type === 'managed-wordpress' ? item.slug : false;
            this.domain = item && item.type === 'managed-wordpress' ? item.domain : null;
            this.package_id = item && item.type === 'managed-wordpress' ? item.id : null;
        },

        updateWp() {
            let wpPackage = this.config.find(c => c.id == this.package_id);

            if (this.data.active.managedWordpress) {
                window.bus.$emit('order.items.update', this.type, this.data.active.managedWordpress, {
                    package_id: this.package_id,
                    domain: this.domain,
                    package: wpPackage.name,
                    price: {
                        rrp: 0,
                        discount: 0,
                        total: wpPackage.priceWithTax,
                    },
                });
            } else {
                if (this.addingAnItem) {
                    return;
                }

                this.addingAnItem = true;

                let itemData = {
                    domain: this.domain,
                    package: wpPackage.name,
                    package_id: this.package_id,
                };

                window.bus.$once('order.items.creating', tempItem => {
                    this.data.active.managedWordpress = this.slug = tempItem.slug;
                });

                window.bus.$once('order.items.created', response => {
                    this.addingAnItem = false;
                    this.data.active.managedWordpress = this.slug = response.data.slug;
                    window.bus.$emit('order.items.update', this.type, response.data.slug, itemData);
                });

                window.bus.$emit('order.items.create', this.type, {
                    price: {
                        rrp: 0,
                        discount: 0,
                        total: wpPackage.priceWithTax,
                    },
                    ...itemData,
                });
            }
        },
    },

    computed: {
        addingToOrder() {
            return ! this.editingOrder;
        },

        editingOrder() {
            return !! this.data.active.managedWordpress;
        },

        activeItem() {
            let item = this.order.items.find(
                item => item.type === this.type && item.slug === this.data.active.managedWordpress
            );

            this.setItemToEdit(item);

            return item;
        },
    },

}
</script>

<style lang="scss" scoped>
    .sau-bundle-card .icon-sau-dedicated:before {
        content: "\E003" !important;
    }
    .sau-bundle-card .sau-server-box header i {
        line-height: 1rem;
    }
    .price-box .price {
        font-size: 2rem !important;
    }
</style>
